var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.5 25.875V32.85C49.5 37.8905 49.5 40.4107 48.5191 42.3359C47.6562 44.0294 46.2794 45.4062 44.5859 46.2691C42.6607 47.25 40.1405 47.25 35.1 47.25H18.9C13.8595 47.25 11.3393 47.25 9.41409 46.2691C7.72063 45.4062 6.3438 44.0294 5.48094 42.3359C4.5 40.4107 4.5 37.8905 4.5 32.85V21.15C4.5 16.1095 4.5 13.5893 5.48094 11.6641C6.3438 9.97063 7.72063 8.5938 9.41409 7.73094C11.3393 6.75 13.8595 6.75 18.9 6.75H28.125M42.75 18V4.5M36 11.25H49.5M36 27C36 31.9706 31.9706 36 27 36C22.0294 36 18 31.9706 18 27C18 22.0294 22.0294 18 27 18C31.9706 18 36 22.0294 36 27Z",
    stroke: "#525050",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraPlus);
export default __webpack_public_path__ + "static/media/camera-plus.10175ffa071c037d47ee14dc76498665.svg";
export { ForwardRef as ReactComponent };